// extracted by mini-css-extract-plugin
export default {"searchBlock":"SearchBlock_searchBlock__nG7aG","searchContainer":"SearchBlock_searchContainer__JW6sm"};